import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { TranslateService } from "../../../../common/variables/translate-service";
import { AddressType } from "../../../../common/lib/addressType";
import { DocAddressOutput } from "../../../../common/api/DocAddressGetAll";

@Component({
  selector: 'sen-app-psd-editor-address',
  templateUrl: './psd-editor-address.component.html',
  styleUrls: ['./psd-editor-address.component.scss']
})
export class PsdEditorAddressComponent implements OnInit {
  type = AddressType.editor;
  @Input() data: DocAddressOutput;
  @Output() address = new EventEmitter<Event>();

  constructor(public global: GlobalVariableService, public translate: TranslateService) { }

  ngOnInit(): void {
  }

  emitAddress(event: any) {
    this.address.emit(event);
  }

}
